import React from 'react'
import Grid from '@mui/material/Grid2';
import { Divider, Typography } from '@mui/material';
import ViewGuestInformation from './ViewGuestInformation';
import BlankCard from 'src/components/shared/BlankCard';

const ManageGuestInformation = ({isView}) => {
    return (
        <Grid container spacing={0}>
            <Grid item size={12}>
                <BlankCard>
                    <Grid container>
                        <Grid item size={12}>
                            <Typography variant="h5" m={2}> {isView ? "View" : ""} Guest Information </Typography>
                        </Grid>
                    </Grid>
                    <Divider />
                    {isView ? <ViewGuestInformation /> : ""}
                </BlankCard>
            </Grid>
        </Grid>
    )
}

export default ManageGuestInformation